Object.defineProperty(exports,"__esModule",{value:true});var _dismissKeyboard=require('../../modules/dismissKeyboard');var _dismissKeyboard2=_interopRequireDefault(_dismissKeyboard);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Keyboard={addListener:function addListener(){},dismiss:function dismiss(){(0,_dismissKeyboard2.default)();},removeAllListeners:function removeAllListeners(){},removeListener:function removeListener(){}};exports.default=Keyboard;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/apis/Keyboard/index.js
 ** module id = 815
 ** module chunks = 0
 **/